import { ReactNode } from 'react';
import { useForm, UseFormReturn, FieldValues } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Paper, Typography } from '@mui/material';
import * as yup from 'yup';

interface BaseFormProps<T extends FieldValues> {
  title?: string;
  schema: yup.ObjectSchema<T>;
  defaultValues?: Partial<T>;
  onSubmit: (data: T) => void | Promise<void>;
  children: (form: UseFormReturn<T>) => ReactNode;
  loading?: boolean;
}

export const BaseForm = <T extends FieldValues>({
  title,
  schema,
  defaultValues,
  onSubmit,
  children,
  loading: _loading = false,
}: BaseFormProps<T>) => {
  const form = useForm<T>({
    resolver: yupResolver(schema) as any,
    defaultValues: defaultValues as any,
    mode: 'onChange',
  });

  const handleSubmit = form.handleSubmit(async data => {
    await onSubmit(data);
  });

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      {title && (
        <Typography variant="h5" component="h1" gutterBottom align="center">
          {title}
        </Typography>
      )}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        {children(form as UseFormReturn<T>)}
      </Box>
    </Paper>
  );
};
